<template>
  <v-container max-width="750" class="vh-footer ps-re lynn-mobile lynn-web-in bg-gray pt0" fluid>
    <div class="web-side"></div>
    <div class="location-box np">
      <div class="web-logo">
        <Weblogo width="55" height="30" />
      </div>
      <a @click="$router.go(-1)" class="back">
        <Back />
      </a>
      <strong class="lo-title">임대계약신청</strong>
    </div>
    <v-card max-width="750" class="mx-auto bg-gray nops">
      <div class="complete-box">
        <div
          class="comin-box"
          :class="{ mt20: i > 0 }"
          v-for="(item, i) in items"
          :key="'pre-contract-' + i"
        >
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">단지</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{ item.village_name }}</span>
          </div>
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">동/호</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{ dongHoText(item) }}</span>
          </div>
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">룸타입</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{ item.type || "미배정" }}</span>
          </div>
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">신청자명</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{ item.contractor_name }}</span>
          </div>
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">전화번호</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{
              item.contractor_mobile | hyphen
            }}</span>
          </div>
          <div class="comin-cont">
            <strong class="text-left ds-b fts12 ftw5 lh24 color-6 mb5">진행상태</strong>
            <span class="text-left ds-b fts14 lh24 color-5">{{ item.state }}</span>
          </div>
        </div>

        <!-- 신청 내역이 없을 때 -->
        <div class="complete-box" v-if="!items.length">
          <div class="comin-box">
            <div class="comin-cont no-mes">
              <span class="text-center ds-b fts14 lh24 color-5">신청 내역을 찾을 수 없습니다.</span>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions class="justify-center pl20 pr20 pt10">
        <v-btn color="primary" class="fts18 ftw7 mw-750 pwidth100" min-height="50" @click="goDashboard()">확인</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { getPreContracts } from "@/api/contract.js";
import Weblogo from "@/assets/images/common/new-logo.svg";
import Back from "@/assets/images/icon/icon-back.svg";

export default {
  name: "PreContractList",
  components: {
    Back,
    Weblogo,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    dongHoText(item) {
      if (!item.dong && !item.ho) {
        return "미배정";
      }
      return `${item.dong}동 ${item.ho}호`;
    },
    getPreContractsAPI() {
      getPreContracts()
        .then((res) => {
          this.items = res.data;
        })
        .catch((error) => {
          this.items = [];
          this.$store.commit("ERROR", "임대계약 신청 내역을 조회할 수 없습니다.");
        });
    },
    goDashboard() {
      this.$router.push({ name: "mypage" });
    },
  },
  created() {
    this.getPreContractsAPI();
  },
};
</script>
